import React from 'react';
import { Link } from 'react-router-dom';
import { useStore } from '../context/StoreContext.jsx';
import { BRAND } from '../config/brand.js';

function Doc({ title, children }) {
  return (
    <div className="page page--narrow doc">
      <h1 className="page__title">{title}</h1>
      {children}
    </div>
  );
}

export function About() {
  return (
    <Doc title="Who We Are">
      <p>{BRAND} is an online boutique for women's clothing and handbags. We choose pieces that are easy to wear, well finished and available in a full range of sizes.</p>
      <p>Every clothing item lists the sizes we have in stock, so you can see what is available before you order. Orders are confirmed with you before they are sent, and payment is on delivery.</p>
      <p><Link to="/shop/clothing">Shop clothing</Link> or <Link to="/shop/handbags">shop handbags</Link>.</p>
    </Doc>
  );
}

export function Contact() {
  const { settings } = useStore();
  const c = settings.contact || {};
  const none = !c.email && !c.phone && !c.whatsapp && !c.address;
  return (
    <Doc title="Contact Us">
      {none && <p>Contact details will be added soon.</p>}
      <dl className="contact">
        {c.email && (<><dt>Email</dt><dd><a href={`mailto:${c.email}`}>{c.email}</a></dd></>)}
        {c.phone && (<><dt>Phone</dt><dd><a href={`tel:${c.phone.replace(/\s/g, '')}`}>{c.phone}</a></dd></>)}
        {c.whatsapp && (<><dt>WhatsApp</dt><dd><a href={`https://wa.me/${c.whatsapp.replace(/\D/g, '')}`} target="_blank" rel="noreferrer">{c.whatsapp}</a></dd></>)}
        {c.address && (<><dt>Address</dt><dd>{c.address}</dd></>)}
      </dl>
      <p>Please include your order number when you write to us about an existing order.</p>
    </Doc>
  );
}

export function Privacy() {
  return (
    <Doc title="Privacy Policy">
      <p>We collect the details you give us when you place an order: your name, email address, phone number and delivery address. We use them to confirm, deliver and support your order, and to contact you about it.</p>
      <p>We do not sell your personal information. We share it only with the delivery partners who need it to bring your order to you.</p>
      <p>Your bag and wishlist are saved in your own browser. You can clear them at any time from your browser settings.</p>
      <p>To ask us to correct or remove your details, use the contact page.</p>
    </Doc>
  );
}

export function Terms() {
  return (
    <Doc title="Terms and Conditions">
      <h3>Orders and payment</h3>
      <p>All orders are paid in cash on delivery. We may contact you to confirm an order before dispatch, and we may cancel an order if an item is no longer available.</p>
      <h3>Prices and shipping</h3>
      <p>Prices are shown in Pakistani rupees. Shipping charges, and the order value above which shipping is free, are shown in your bag and at checkout.</p>
      <h3>Sizes</h3>
      <p>Each clothing item lists the sizes available. Please check the fit and size notes on the product page. Colours may look slightly different on your screen.</p>
      <h3>Exchanges and returns</h3>
      <p>Unworn items with tags attached may be exchanged within 7 days of delivery. Please contact us first with your order number.</p>
    </Doc>
  );
}
